import React from 'react';
import { ArrowRight, History } from 'lucide-react';

const fmt = (iso) => {
  if (!iso) return '';
  try { return new Date(iso).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }); } catch { return iso; }
};

export const OwnershipHistory = ({ history }) => {
  const rows = [...(history || [])].sort((a, b) => (b.at || '').localeCompare(a.at || ''));
  return (
    <div className="border border-slate-200 rounded-lg p-4" data-testid="ownership-history">
      <div className="flex items-center gap-2 mb-2">
        <History className="w-4 h-4 text-slate-500" />
        <h4 className="text-sm font-semibold text-slate-800">Ownership History</h4>
        <span className="text-xs text-slate-400">{rows.length} change{rows.length === 1 ? '' : 's'}</span>
      </div>
      {rows.length === 0 ? (
        <p className="text-xs text-slate-400" data-testid="ownership-history-empty">No ownership changes recorded yet.</p>
      ) : (
        <ol className="space-y-2 max-h-56 overflow-y-auto pr-1">
          {rows.map((h, i) => (
            <li key={`${h.at}-${i}`} className="text-xs flex flex-wrap items-center gap-x-2 gap-y-0.5" data-testid={`ownership-history-row-${i}`}>
              <span className={`px-1.5 py-0.5 rounded font-semibold ${h.role === 'sales' ? 'bg-indigo-50 text-indigo-700' : 'bg-teal-50 text-teal-700'}`}>
                {h.role === 'sales' ? 'Sales' : 'Pre-Sales'}
              </span>
              <span className="text-slate-500">{h.from_name || 'Unassigned'}</span>
              <ArrowRight className="w-3 h-3 text-slate-400" />
              <span className="font-medium text-slate-800">{h.to_name || 'Unassigned'}</span>
              <span className="text-slate-400">· {h.reason_label || h.reason}</span>
              <span className="text-slate-400">· by {h.by_name || 'System'}</span>
              <span className="text-slate-400 ml-auto">{fmt(h.at)}</span>
              {(h.payments_moved > 0 || h.bookings_moved > 0) && (
                <span className="w-full text-slate-500" data-testid={`ownership-history-moved-${i}`}>
                  {h.payments_moved > 0 && `${h.payments_moved} payment${h.payments_moved === 1 ? '' : 's'} moved`}
                  {h.payments_moved > 0 && (h.revenue_moved > 0
                    ? ` · ₹${Number(h.revenue_moved).toLocaleString('en-IN')} revenue credited to ${h.to_name || 'the new owner'}`
                    : ' · no revenue credit (trial / add-on only)')}
                  {h.bookings_moved > 0 && `${h.payments_moved > 0 ? ' · ' : ''}${h.bookings_moved} consultation${h.bookings_moved === 1 ? '' : 's'} moved`}
                </span>
              )}
              {h.note && <span className="w-full text-slate-500 italic">“{h.note}”</span>}
            </li>
          ))}
        </ol>
      )}
    </div>
  );
};

export default OwnershipHistory;
